export default __webpack_public_path__ + "static/media/caseSuvinil.417c2983.png";